import { Injectable } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BffCommunicationService } from '../../../core/services/_index';
import { AppConfigService } from '../../../app-config.service';

@Injectable({
  providedIn: 'root'
})
export class DownloadPhotoService {
  constructor(
    private readonly bffApiService: BffCommunicationService,
    private readonly _appConfigService: AppConfigService,
    private readonly _sanitizer: DomSanitizer
  ) {}

  private getApiUrl() {
    const idProjet = this._appConfigService.idProjet;
    return `/api/v2/projets/${idProjet}/images`;
  }

  private getPropertyPhotoData(idPhoto: string): Observable<Blob> {
    return this.bffApiService.getPropertiyPhoto(`${this.getApiUrl()}/${idPhoto}`);
  }

  getPhotoUrl(idPhoto: string): Observable<SafeUrl> {
    return this.getPropertyPhotoData(idPhoto).pipe(
      map((photoData: Blob) => {
        const photoUrl = URL.createObjectURL(photoData);
        return this._sanitizer.bypassSecurityTrustUrl(photoUrl.toString());
      })
    );
  }
}
